define(['jquery', 'c21/charts/ChartGroup'], function ($, ChartGroup) {
   "use strict";

   var m_oData,
      m_jChartContainer,
      m_jSelect,
      m_chartGroup,
      m_labels;
   
   return {
      initialize : function(oData) {
         m_oData = oData;
         m_labels = {
            age: {
               bars: [
                 { title: '0-5', key: 'population_aged_0_5_pct' },
                 { title: '6-11', key: 'population_aged_6_11_pct' },
                 { title: '12-17', key: 'population_aged_12_17_pct' },
                 { title: '18-24', key: 'population_aged_18_24_pct' },
                 { title: '25-34', key: 'population_aged_25_34_pct' },
                 { title: '35-44', key: 'population_aged_35_44_pct' },
                 { title: '45-54', key: 'population_aged_45_54_pct' },
                 { title: '55-64', key: 'population_aged_55_64_pct' },
                 { title: '65-74', key: 'population_aged_65_74_pct' },
                 { title: '75-84', key: 'population_aged_75_84_pct' },
                 { title: '85+', key: 'population_aged_85p_pct' }
               ]
            },
            ethnicity: {
               bars: [
                 { title: 'White', key: 'population_white_pct' },
                 { title: 'Hispanic', key: 'population_hispanic_pct' },
                 { title: 'Black', key: 'population_black_pct' },
                 { title: 'Asian', key: 'population_asian_pct' },
                 { title: 'Native American', key: 'population_american_indian_or_alaskan_native_pct' },
                 { title: 'Other', key: 'population_other_race_pct' },
               ]
            },
            education: {
               bars: [
                 { title: 'Some High School', key: 'education_some_hs_pct' },
                 { title: 'Some College', key: 'education_some_college_pct' },
                 { title: 'Associates Degree', key: 'education_assoc_degree_pct' },
                 { title: 'Bachelors Degree', key: 'education_bach_degree_pct' },
                 { title: 'Graduate', key: 'education_grad_degree_pct' },
               ]
            },
            income: {
               sublabel: '&nbsp;(in thousands of dollars)',
               bars: [
                 { title: 'Under $15k', key: 'households_income_less_than_15000_pct' },
                 { title: '$15-24,999k', key: 'households_income_15000_24999_pct' },
                 { title: '$25-34,999k', key: 'households_income_25000_34999_pct' },
                 { title: '$35-49,999k', key: 'households_income_35000_49999_pct' },
                 { title: '$50-74,999k', key: 'households_income_50000_74999_pct' },
                 { title: '$75-99,999k', key: 'households_income_75000_99999_pct' },
                 { title: '$100-124,999k', key: 'households_income_100000_124999_pct' },
                 { title: '$125-149,999k', key: 'households_income_125000_149999_pct' },
                 { title: '$150-199,999k', key: 'households_income_150000_199999_pct' },
                 { title: 'Over $200k', key: 'households_income_200000_and_over_pct' },
               ]
            },
            emp_occ: {
               bars: [
                 { title: 'Management & Financial', key: 'occupation_management_business_and_financial_operations_pct' },
                 { title: 'Professional', key: 'occupation_professional_and_related_pct' },
                 { title: 'Sales and Office', key: 'occupation_sales_and_office_pct' },
                 { title: 'Service', key: 'occupation_service_pct' },
                 { title: 'Farming, Fishing & Forestry', key: 'occupation_construction_extraction_and_maintenance_pct' },
                 { title: 'Transportation & Moving', key: 'occupation_production_transportation_and_material_moving_pct' },
               ]
            },
            emp_ind: {
               bars: [
                 { title: 'Agriculture', key: 'emp_agri_pct' },
                 { title: 'Mining', key: 'emp_mine_pct' },
                 { title: 'Construction', key: 'emp_const_pct' },
                 { title: 'Manufacturing', key: 'emp_manuf_pct' },
                 { title: 'Transportation', key: 'emp_trans_pct' },
                 { title: 'Wholesaling', key: 'emp_whole_pct' },
                 { title: 'Retail', key: 'emp_retail_pct' },
                 { title: 'Finance', key: 'emp_finetc_pct' },
                 { title: 'Real Estate', key: 'emp_real_pct' },
                 { title: 'Other Services', key: 'emp_otsrv_pct' },
                 { title: 'Public Administration', key: 'emp_pubad_pct' },
               ]
            }
         };

         m_jChartContainer = $('#localAreaChart');
         if (m_jChartContainer.length === 0) return;

         m_jSelect = $('#localAreaDataSelect');
         m_chartGroup = new ChartGroup(m_jChartContainer, m_jSelect, m_oData, m_labels);
         m_chartGroup.render();
         //verticalChart.setSublabel($('#localAreaDataSublabel'));
         //m_chartGroup.setSelect(m_jSelect);
      }
   };
});
